<template>
  <section>
    <div id="order_view_model" class="modal fade" role="dialog" ref="viewOrderModal" data-keyboard="false" aria-labelledby="myModalLabel">
      <div class="modal-dialog custom-modal-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              <b class="pull-left">{{ baby }}</b>
            </h4>
            <br/>
          </div>

          <div class="modal-body">
            <div v-if="groupedVaccinationDetails.length > 0">
              <h4>Vaccination Details</h4>
              <table class="table table-bordered table-hover">
                <thead>
                <tr>
                  <th class="text-center align-middle" style="width: 100px;">Age</th>
                  <th class="text-center align-middle">Vaccine</th>
                  <th class="text-center align-middle">Vaccinated Date</th>
                  <th class="text-center align-middle">Description</th>
                  <th class="text-center align-middle">Comments</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(group, groupIndex) in groupedVaccinationDetails" :key="groupIndex">
                  <td v-if="group.rowspan > 0"
                      :rowspan="group.rowspan"
                      style="text-align: center; vertical-align: middle; padding-top: 10px;">{{ group.age }}</td>
                  <td style="text-align: center; vertical-align: middle; padding-top: 10px;">{{ group.vaccine }}</td>
                  <td style="text-align: center; vertical-align: middle; padding-top: 10px;">{{ group.date ? $moment(group.date).format('DD/MM/YYYY') : 'N/A' }}</td>
                  <td style="vertical-align: middle; padding-top: 10px;">{{ group.description }}</td>
                  <td v-if="group.rowspan > 0"
                      :rowspan="group.rowspan"
                      style=" vertical-align: middle; padding-top: 10px;">{{ group.comments }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <p class="text-center">No vaccination details to show.</p>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="close" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import axios from "axios";
import commonMethods from "@/Mixins/CommonMethods";

export default {
  name: "ViewBabyVaccinationChart",
  props: ['babyName'],
  data: function () {
    return {
      vaccinationDetails: [],
      baby: ''
    }
  },
  computed: {
    groupedVaccinationDetails() {

      const groups = [];
      let prevAge = '';
      let rowspan = 0;
      this.vaccinationDetails.forEach((detail, index) => {

        const currentAge = detail.vaccineChart.age;
        if (currentAge === prevAge) {
          rowspan = 0;
        } else {
          rowspan = this.vaccinationDetails.filter(d => d.vaccineChart.age === currentAge).length;
          prevAge = currentAge;
        }

        const ageGroup=this.vaccinationDetails.filter(d => d.vaccineChart.age === currentAge);
        let comments = 'N/A';
        ageGroup.forEach(d => {
          if (d.comments && d.comments.trim() !== '') {
            comments = d.comments;
          }
        });

        groups.push({
          age: currentAge,
          vaccine: detail.vaccineChart.vaccine,
          date: detail.date,
          description: detail.vaccineChart.description,
          comments: comments,
          rowspan,
        });
      });

      return groups;
    },
  },
  methods: {
    fetchBabyVaccinationDetails: function (babyId, babyName) {
      axios.get(`${this.$store.state.mainAppURL}baby_names/baby_vaccination_details/${babyId}`)
          .then((response) => {
            this.vaccinationDetails = response.data.body;
            this.baby = babyName;
            $("#order_view_model").modal("show");
          })
          .catch(function (error) {
            this.showErrorMessage(error)
          });
    },
    close() {},
  }
}
</script>

<style scoped>
.modal { overflow: auto !important; }
.custom-modal-width {
  width: 60%;
}
.text-center {
  text-align: center;
}
table td {
  vertical-align: middle;
}
</style>